/**
 * Shared helpers for entry-point bootstrap.
 *
 * Classic-script loading must be sequential, phylocanvas-renderer.js depends
 * on PhylocanvasGL existing, app.js depends on the renderer constructor, etc.
 * Setting `script.async = false` preserves execution order while still allowing
 * parallel network fetches.
 */
export function loadClassicScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = src;
    s.async = false;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error(`Failed to load classic script: ${src}`));
    document.head.appendChild(s);
  });
}

/**
 * The phylocanvas UMD installs itself on `window.phylocanvas` or
 * `window.PhylocanvasGL` depending on the runtime. The original Kronos app
 * normalized both into `window.phylocanvas.PhylocanvasGL`; downstream classic
 * scripts read from either location.
 */
export function normalizePhylocanvasGlobals(): void {
  const win = window as unknown as Record<string, unknown>;
  const phyloModule = win['phylocanvas'] as { PhylocanvasGL?: unknown } | undefined;
  const ctor = win['PhylocanvasGL'] ?? phyloModule?.PhylocanvasGL;
  if (!ctor) {
    throw new Error('PhylocanvasGL not exposed by UMD bundle');
  }
  win['PhylocanvasGL'] = ctor;
  win['phylocanvas'] = { PhylocanvasGL: ctor };
}
